export const CREATE_SI_UNIT = "CREATE_SI_UNIT";
export const UPDATE_SI_UNIT = "UPDATE_SI_UNIT";
export const FETCH_SI_UNITS = "FETCH_SI_UNITS";
export const FETCH_SI_UNIT = "FETCH_SI_UNIT";
export const DELETE_SI_UNIT = "DELETE_SI_UNIT";
export const RESET_SI_UNIT = "RESET_SI_UNIT";
export const SI_UNIT_FETCH_FAIL = "SI_UNIT_FETCH_FAIL";
